import deleteUtil from './delete';

export default (maskElement, elementToMask, elements) => {
  const newElements = deleteUtil.element([maskElement], elements);
  elementToMask.maskElements.push(maskElement);

  return newElements;
};
